import styled from 'styled-components';
import colors from './constants/colors';

const Loader = styled.div`
  align-items: center;
  background: ${({ backgroundColor }) => backgroundColor || colors.electricBlue};
  border-radius: 4px;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  pointer-events: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 3;
`;

export default Loader;
